import React, { memo, useImperativeHandle, forwardRef, useMemo, useState, useCallback } from "react";
import PropTypes from "prop-types";

import AppInput from "components/app-input";
import AppButton from "components/app-button";
import searchIcon from "assets/images/search-icon.svg";
import AppCloseIcon from "components/icons/app-close-icon";
import { Dialog } from "@mui/material";

//prettier-ignore
const AppSearchInput = ({ children, ...props }, ref) => {
	const [open, setOpen] = useState(null);
	const isMultiValues = useMemo(() => props.multiValues && Object.keys(props.multiValues).some(o => props.multiValues[o]), [props.multiValues]);

	const onhandleCloseAdvanceSearch = useCallback(() => {
		setOpen(null);
	}, []);

	const onHandleShowAdvanceSearch = useCallback((event) => {
		setOpen(event.currentTarget);
	}, []);

	const onHandleChange = useCallback((event) => {
		props.onChange(event);
	}, [props]);

	const onHandleRemoveField = useCallback((event, field) => {
		event.stopPropagation();
		props.onRemoveField(field);
	}, [props])

	const Pills = useCallback(() => {
		if(!props.multiValues) return null;

		const items = Object.keys(props.multiValues).map((o, i) => {
			if(!props.multiValues[o]) return null;

			return (
				<div className="advance-search__pill" key={i}>
					<p className="advance-search__value">{props.multiValues[o]} </p>
					<button className="advance-search__remove" onClick={(event) => onHandleRemoveField(event, o)}>
						<AppCloseIcon color="#ffffff"/> 
					</button>
				</div> 
			);
		});

		return items;
	}, [props.multiValues, onHandleRemoveField]);

	useImperativeHandle(ref, () => ({
		onhandleCloseAdvanceSearch: onhandleCloseAdvanceSearch,
		onHandleShowAdvanceSearch: onHandleShowAdvanceSearch,
	}));

	return (
		<div className="app-search-input">
			<div className="search-input">
				{children && 
					<div className="advance-search">

						<div className="advance-search__input">
							{!isMultiValues}
							<Pills />
						</div>
					</div>
				}

				{props.onChange && !props.multiValues && <AppInput type="text" name="search" placeholder="Searching for..." icon={searchIcon} defaultValue={props.defaultValue} onChange={onHandleChange} onClear={props.onClear} onBlur={() => {}} />}
			</div>

			{children && <Dialog classes={{ root: "app-search-menu" }} open={open} onClose={onhandleCloseAdvanceSearch} fullWidth maxWidth="sm">{children}</Dialog>}

			{props.buttons && !props.hideButton && (
				<div className="app-search-input__button-container">
					{props.buttons?.map((o, i) => <AppButton key={i} type="button" {...o} label={o.label} icon={o.icon} outline={o.outline} onClick={o.onClick} disabled={o.disabled} />)}
				</div>
			)}
		</div>
	);
};

export default memo(forwardRef(AppSearchInput));

const buttonPropsType = (props, propsName, components) => {
	const propsType = {
		buttonIcon: PropTypes.string.isRequired,
		buttonLabel: PropTypes.string.isRequired,
		onButtonClick: PropTypes.func.isRequired,
	};

	if (props.buttonIcon || props.buttonLabel || props.onButtonClick) return PropTypes.checkPropTypes(propsType, props, propsName, components);

	return null;
};

const advanceSearchPropType = (props, propsName, components) => {
	const propsType = {
		multiValues: PropTypes.object.isRequired,
		onRemoveField: PropTypes.func.isRequired,
	};

	if (props.multiValues || props.onRemoveField) return PropTypes.checkPropTypes(propsType, props, propsName, components);

	return null;
};

AppSearchInput.propTypes = {
	multiValues: advanceSearchPropType,
	onRemoveField: advanceSearchPropType,
	onClear: PropTypes.func,
	onChange: PropTypes.func,
	buttonIcon: buttonPropsType,
	buttonLabel: buttonPropsType,
	onButtonClick: buttonPropsType,
};
